import React, { Component } from "react";
import Head from "next/head";
import getConfig from "next/config";
import withRouterPageLayout from "@components/withRouterPageLayout.js";

import Breadcrumbs from "@components/Breadcrumbs";
import Heading from "@components/Heading";
import Button from "@components/Button";

const {
  publicRuntimeConfig: {
    content: { websiteTitle },
  },
} = getConfig();

let solutions = [
  {
    name: `Carduri de credit`,
    desc: `Programe de rate cu dobanda si fara, pentru posesorii cardurilor de credit`,
    path: "/solutii-finantare/sisteme-rate-valabile-pentru-posesorii-cardurilor-credit/",
    bg: "#ebebeb",
  },
  {
    name: `Credit instant in magazin`,
    desc: `Achizitionezi orice produs doresti, in rate, direct din magazinele ${websiteTitle}`,
    path: "/solutii-finantare/credit-consum-traditional/",
    bg: "#faebef",
  },
  {
    name: `Credit de consum online`,
    desc: `SIMPLU si RAPID pentru implinirea viselor tale!`,
    path: "/solutii-finantare/credit-online/",
    bg: "#eff1fe",
  },
];

class FinancingSolutions extends Component {
  render() {
    return (
      <>
        <Head>
          <title>{`Solutii de finantare`}</title>
        </Head>

        <Breadcrumbs
          breadcrumbs={[
            {
              id: 1,
              level: 99,
              name: `Solutii de finantare`,
            },
          ]}
        />

        <Heading
          as="h1"
          display="h1"
          title={`Solutii de finantare`}
          classesProp="my-6"
        />

        <div className="flex flex-wrap -mx-3 text-center">
          {solutions.map((sol, i) => (
            <div
              key={`${sol.bg}-${i}`}
              className="w-full mb-3 md:w-1/3 px-3 md:mb-0"
            >
              <div
                className="p-4 md:p-10 flex flex-col items-center justify-center h-full rounded-tr-lg rounded-bl-lg"
                style={{ backgroundColor: sol.bg }}
              >
                <Heading
                  as="h2"
                  display="h2"
                  title={sol.name}
                  classesProp="mb-4 has-min-height"
                />
                <p className="text-sm pb-6 mb-auto w-full">{sol.desc}</p>
                <Button title={`Vezi detalii`} href={sol.path} />
              </div>
            </div>
          ))}
        </div>

        <style jsx>{`
          @media (min-width: 1000px) {
            .has-min-height {
              min-height: 86px;
            }
          }
        `}</style>
      </>
    );
  }
}

FinancingSolutions.pageLayout = "default";

export default withRouterPageLayout(FinancingSolutions);
